/* eslint-disable no-console */
import {Flex} from 'antd';
import React from 'react';

import facilityImage from '../../../../../assets/facilityImage.png';

const FacilityPopUp: React.FC<{
  mapData: any;
}> = ({mapData}) => {
  return (
    <Flex className="popupFacility">
      <div className="facilityImage">
        <img src={facilityImage} height={68} width={68} />
      </div>
      <div className="facilityDetails">
        <div className="facilityName">{mapData?.name}</div>
        <div className="addressPopup">{`${mapData?.fullAddress}`}</div>
      </div>
    </Flex>
  );
};

export default FacilityPopUp;
